"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tremezzina": {
    "c867a9c5": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "azzano": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf24f679": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "bolvedro": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c61a92e1": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "bonzanigo": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7eb923d": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "campo": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3a5c99f": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "carate": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3892b610": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "casanova": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d7d7218": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "era": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1d78497": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "ganzo": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c79907e": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "garzola": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "88132b35": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "giulino": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff510663": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "isola-sulla-terra-ferma": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb62037f": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "isola-comacina-castel-o-san-giovanni": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c52668b1": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "l-antica-balbiano": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fc6347b": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "le-grane-e-mulina-l-antica-perlana": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5db6d59": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "masnate": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec2f7004": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "molgisio": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7dc71f57": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "ospedaletto-stabio-fino-al-1810": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7a65a6e": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "pola": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5265cb4": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "portezza": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c3ae70f": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "rogaro": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d646f7b8": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "saleno": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "acc43b55": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "soccorso": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4897de6c": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "spurano": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6e8c8dc": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "tregola": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1986f4c": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "e5f8694f",
      "slug": "tremezzina",
      "name": "Tremezzina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;